<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("tailoring order") }}</div>
    <div class="grid is-col-min-7">
      <div class="cell" @click="orders">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/7835/7835565.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("orders") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="order_validator">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.freepik.com/256/3963/3963671.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("order validator") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="cell" @click="cutting">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://static.vecteezy.com/system/resources/previews/008/415/514/non_2x/a-cute-woman-is-sewing-the-girl-makes-a-pattern-on-the-fabric-for-a-dress-clothing-patternmaker-flat-illustration-vector.jpg"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("cutting") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="cell" @click="sewing">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/3669/3669548.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("sewing") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="delivery">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2272/2272267.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("delivery") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { warning_message, get } from "@/utils";

export default {
  name: "TailoringOrderIndex",
  components: {},
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    orders() {
      let v = this;
      v.$router.push({
        path: "/tailoring_order/orders",
      });
    },
    delivery() {
      let v = this;
      v.$router.push({
        path: "/tailoring_order/delivery",
      });
    },
    sewing() {
      let v = this;
      v.$router.push({
        path: "/tailoring_order/sewing",
      });
    },
    cutting() {
      let v = this;
      v.$router.push({
        path: "/tailoring_order/cutting",
      });
    },
    order_validator() {
      let v = this;
      v.$router.push({
        path: "/tailoring_order/order-validator",
      });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}
.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}
</style>
